// Export Sidebar and Sidebar Reducer

import Sidebar from "./sidebarContainer";
import sidebarReducer from "./reducer";

export default Sidebar;
export { sidebarReducer };



// WEBPACK FOOTER //
// ./src/pretravel/components/Sidebar/index.js